import {ProjectsConstants} from "../constants/projectConstants";

export class WordstatHelper
{
    /**
     * Получаем слаг источника по ID (source)
     * @param {Number} sourceId - ID источника
     * @returns {String}
     */
    static getSourceSlug(sourceId)
    {
        switch (sourceId) {
            case ProjectsConstants.SOURCE_WS:
                return 'ws';
            case ProjectsConstants.SOURCE_DIRECT:
                return 'direct';
            default:
                return 'ws';
        }
    }
}
